var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReports = function SvgReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2a2 2 0 1 1 1.482 1.932l-3.55 3.55Q16 7.731 16 8a2 2 0 1 1-3.996-.129L8.887 5.793a2 2 0 0 1-1.405.14l-3.55 3.549A2.003 2.003 0 0 1 2 12a2 2 0 1 1 .518-3.932l3.55-3.55A2.003 2.003 0 0 1 8 2a2 2 0 0 1 1.996 2.129l3.117 2.078a2 2 0 0 1 1.405-.14l3.55-3.549A2 2 0 0 1 18 2M19 7a1 1 0 1 1 2 0v14a1 1 0 1 1-2 0zM14 12a1 1 0 0 0-1 1v8a1 1 0 1 0 2 0v-8a1 1 0 0 0-1-1M2 14a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0v-6a1 1 0 0 0-1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8a1 1 0 0 0-1 1v12a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1"
  })));
};
export default SvgReports;